export type { FaqEntry } from './en'
import { enFaq } from './en'
import { deFaq } from './de'
import { jaFaq } from './ja'
import type { FaqEntry } from './en'

/**
 * Returns the FAQ entries for the given language code.
 * Falls back to English for unsupported languages.
 *
 * To add a new language, create `src/faq/<lang>.ts` exporting
 * `const <lang>Faq: FaqEntry[]`, then add a case below.
 */
export function getFaqContent(lang: string): FaqEntry[] {
  switch (lang) {
    case 'de':
      return deFaq
    case 'ja':
      return jaFaq
    default:
      return enFaq
  }
}
